import React from "react";
import {ReactKeycloakProvider} from "@react-keycloak/web";
import {SecureProvider} from "./secure-provider";
import Keycloak from "keycloak-js";
import {CircularProgress, MuiThemeProvider} from "@material-ui/core";
import {KEYCLOAK_CONFIG} from "../config/front-config";
import {GlobalStyles, theme} from "../global/global.styles";
import {ThemeProvider} from "styled-components";
import {createTheme} from "@material-ui/core/styles";
import {setLocale} from "yup";
import {LocaleFR} from "../locale/validation-locale";
import {BaseAppProviderProps} from "@betrue/common";

export interface AppProviderProps extends BaseAppProviderProps {
  loginMode?: string

}
const muiTheme = createTheme({
  typography: theme.typography
});
setLocale(LocaleFR)
export function AppProvider(props: AppProviderProps) {

  const kc = Keycloak(
    {
      url: KEYCLOAK_CONFIG().authServerUrl,
      realm: KEYCLOAK_CONFIG().realm,
      clientId: KEYCLOAK_CONFIG().clientId,

    }
  )

  return (
    <MuiThemeProvider theme={muiTheme}>
      <ThemeProvider
        theme={theme}>
        <GlobalStyles/>
        <ReactKeycloakProvider authClient={kc}
                               LoadingComponent={<CircularProgress/>}
                               initOptions={KEYCLOAK_CONFIG().init}>
          <SecureProvider loginMode={props.loginMode}>
            {props.children}
          </SecureProvider>
        </ReactKeycloakProvider>
      </ThemeProvider>
    </MuiThemeProvider>
  );
}

export default AppProvider;
